import React, { FC, useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import closeIcon from "../../../../assets/icons/close.svg";
import "./examForm.scss";
import ToggleSwitch from "../../ToggleSwitch";
import UploadLogo from "../../UploadLogo";
import { Formik, Form, Field } from "formik";
import ButtonComponent from "../../ButtonComponent";
import InputField from "../../InputField";
import { ExamService } from "../../../../services/ExamService/exam.service";
import { serialize } from "serializr";
import { ExamModel } from "../../../../models/ExamModels/exam.model";
import { convertJSONToFormData } from "../../../utils/converJsonToFormData";
import { ClassFormValidation } from "../../CourseComponents/courseValidation";

interface ExamFormProps {
  title: string;
  visible: boolean;
  setVisible: Function;
  data?: any;
  refreshList: Function;
  currentPageNumber?: number;
}

const ExamForm: FC<ExamFormProps> = (props) => {
  const { title, visible, setVisible, data, refreshList, currentPageNumber } =
    props;
  const formRef = useRef<any>();

  useEffect(() => {
    console.log(data);
    setInitialValues({
      name: data?.name || null,
      acronym: data?.acronym || null,
      amount: data?.amountPaise || data?.amountRupees || data?.amount,
      description: data?.description || null,
      isActive: data?.isActive ? data.isActive : false,
      displayPictureUrl: data?.displayPictureUrl || "",
    });
  }, [data]);

  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>({
    name: null,
    acronym: null,
    isActive: true,
    amount: null,
    description: null,
    displayPictureUrl: null,
  });

  const handleClose = () => {
    setVisible(false);
    formRef.current.resetForm(initialValues);
  };

  const handleSubmit = (values: any) => {
    console.log(values);
    setButtonLoading(true);

    let examData = serialize(ExamModel, values);
    if (values?.displayPicture)
      examData.display_picture = values.displayPicture;
    let jsonData = { exam: examData };
    let examFormData = convertJSONToFormData(jsonData);

    console.log(examFormData);
    if (!data) {
      ExamService.createNewExam(
        examFormData,
        (response: any) => {
          refreshList(currentPageNumber);
          setVisible(false);
          setButtonLoading(false);
          formRef.current.resetForm(initialValues);
        },
        (error: any) => {
          setButtonLoading(false);
        }
      );
    } else {
      ExamService.updateExam(
        {
          id: data?.id,
          exam: examData,
        },
        (response: any) => {
          if (refreshList) refreshList(currentPageNumber);
          setVisible(false);
          setButtonLoading(false);
          formRef.current.resetForm(initialValues);
        },
        (error: any) => {
          setButtonLoading(false);
        }
      );
    }
  };

  return (
    <Modal
      title={null}
      centered
      visible={visible}
      onCancel={handleClose}
      footer={null}
      className="exam-form__modal"
      closeIcon={<img src={closeIcon} alt="" />}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formRef}
        validationSchema={ClassFormValidation}
      >
        {({ setFieldValue, values, resetForm }) => {
          return (
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="exam-form__header">
                <div className="exam-form__title">{title}</div>
                <div className="exam-form__toggle">
                  <Field name="isActive" as="switch">
                    <ToggleSwitch
                      checked={values.isActive}
                      handleChange={() => {
                        setFieldValue("isActive", !values.isActive);
                      }}
                    />
                  </Field>
                </div>
              </div>

              <Field name="displayPicture" as="file-upload">
                <UploadLogo
                  logoUrl={
                    values?.displayPicture
                      ? values?.displayPicture
                      : data?.displayPictureUrl
                  }
                  setFile={setFieldValue}
                />
              </Field>

              <div className="exam-form__input">
                <div className="exam-form__label">Name of exam *</div>
                <InputField
                  type="text"
                  name="name"
                  placeholder="Type exam name"
                />
              </div>

              <div className="exam-form__input">
                <div className="exam-form__label">Acronym *</div>
                <InputField
                  type="text"
                  name="acronym"
                  placeholder="Type acronym"
                />
              </div>
              <div className="exam-form__input">
                <div className="exam-form__label">Description *</div>
                <InputField
                  type="textarea"
                  name="description"
                  placeholder="Type description"
                  className={"exam-form__description"}
                />
              </div>
              <div className="exam-form__input">
                <div className="exam-form__label">Subscription cost *</div>
                <InputField
                  type="text"
                  name="amount"
                  placeholder={"Enter cost"}
                />
              </div>
              <div className="exam-form__action">
                <div
                  className="exam-form__button"
                  onClick={() => {
                    handleClose();
                    resetForm({});
                  }}
                >
                  <ButtonComponent buttonContent="Cancel" type="text" />
                </div>
                <div className="exam-form__button">
                  <ButtonComponent
                    buttonContent={data ? "Update" : "Create"}
                    type="primary"
                    htmlType="submit"
                    loading={buttonLoading}
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default ExamForm;
